export const AUDIT_PARTNER = {
	name: 'MoveBit',
	url: 'http://movebit.xyz/reports/Suigar-Audit-Report-2025-11-10.pdf',
	label: 'Audited by MoveBit',
};
